// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link_Link__cYhAw","Link___color-inherit":"Link_Link___color-inherit__vit9h"};